import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import { Button } from '@avangard/ui/core';
import { gray } from '@avangard/ui/colors';

type TestingNavigationProps = {
    currentIndex: number;
    questionsLength: number;
    onPreviousClick: VoidFunction;
    onNextClick: VoidFunction;
};

const Navigation = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`;

const NavigationButton = styled(Button)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    min-width: 40px;
    width: 40px;
    padding: 0;
    line-height: 0;
    border-radius: 4px;
`;

const NavigationQuestionNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 16px;
    color: ${gray[80]};
    font-size: 2rem;
    font-weight: 700;
`;

const TestingNavigation = memo((props: TestingNavigationProps): React.ReactElement => {
    const { currentIndex, questionsLength, onPreviousClick, onNextClick } = props;

    const { t } = useTranslation(['testing']);

    const isSingleQuestion = questionsLength === 1;

    return (
        <Navigation className='testing-nav'>
            <NavigationButton
                variant='outlined'
                disabled={isSingleQuestion}
                onClick={onPreviousClick}
            >
                <ChevronLeft fontSize='large' />
            </NavigationButton>

            <NavigationQuestionNumber>
                {t('testing:blocks.titles.index_from_length', {
                    index: currentIndex,
                    length: questionsLength,
                })}
            </NavigationQuestionNumber>

            <NavigationButton variant='outlined' disabled={isSingleQuestion} onClick={onNextClick}>
                <ChevronRight fontSize='large' />
            </NavigationButton>
        </Navigation>
    );
});

export { TestingNavigation };
